import _ from "lodash"
import { responsiveCSSStyle } from "./styles"
import styleColors from "./styleColors"

/**
 * Custom highcharts plot options
 * See API doc: https://api.highcharts.com/highstock/plotOptions
 * @param chartOpts
 * @returns {*}
 */
export default function plotOptionsPlugin(chartOpts) {
  // customize pie
  _.unset(chartOpts, "plotOptions.pie.shadow")
  _.unset(chartOpts, "plotOptions.pie.dataLabels.style")

  _.set(chartOpts, "plotOptions.pie.dataLabels.borderWidth", 0)
  _.set(chartOpts, "plotOptions.pie.dataLabels.shadow", false)
  _.set(
    chartOpts,
    "plotOptions.pie.dataLabels.backgroundColor",
    styleColors.tooltipBackground
  )
  _.set(
    chartOpts,
    "plotOptions.pie.dataLabels.color",
    styleColors.contrastTextColor
  )
  _.set(chartOpts, "plotOptions.pie.dataLabels.style", responsiveCSSStyle())
  return chartOpts
}
